<template>
  <SentimentTimeSeries
    :title="title"
    :item-id="itemId"
    :data-type="dataType"
    v-bind="$attrs"
    :owner-posts="true"
  />
</template>

<script>
import SentimentTimeSeries from '@/components/cards/SentimentTimeSeries';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropSentimentTimeSeries',
  components: {
    SentimentTimeSeries,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    dataType: {
      type: String,
      default: 'absolute',
    },
  },
};
</script>
